/* eslint-disable no-shadow,no-param-reassign */
import _ from "lodash";

const initialState = {
  list: {}
};

export const state = initialState;

export const getters = {
  list: state => {
    const systemList = [];
    const systems = _.filter(
      Object.values(state.list),
      o => !_.has(o.relationships, "system.data.id")
    );
    _.forEach(systems, s => {
      const system = { id: s.id, name: s.attributes.name, symptoms: [] };

      const symptoms = _.filter(
        Object.values(state.list),
        o =>
          _.has(o.relationships, "system.data.id") &&
          o.relationships.system.data.id === system.id
      );

      _.forEach(symptoms, sym => {
        system.symptoms.push({
          id: sym.id,
          name: sym.attributes.name,
          systemId: system.id
        });
      });

      systemList.push(system);
    });

    return systemList;
  },
  name: state => id => state.list[id].attributes.name,
  name2id: state => name => {
    const symptom = _.filter(
      Object.values(state.list),
      o => o.attributes.name === name
    );
    let id = "";
    if (symptom.length) {
      id = symptom[0].id;
    }
    return id;
  }
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  }
};

export const mutations = {
  set(state, data) {
    state.list = Object.assign({}, data);
  }
};
